import TYPES from '@/types';

// Domain
import Inject from '@/modules/shared/domain/di/inject';
import Translator from '@/modules/shared/domain/i18n/translator';
import { Values } from '@/modules/shared/domain/i18n/types';

export default class ChangedDocumentStatusDocumentReceivedViewModel {
  @Inject(TYPES.I18N)
  readonly translator!: Translator;

  readonly i18n_namespace = 'components.allianz-dashboard.changed-document-status.document-received';

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  document_type = '';

  initialize = (document_type: string) => {
    this.document_type = document_type;
  }

  get document_type_text_title() {
    return (this.document_type === 'address') ? this.translate('proof_address') : this.translate('proof_bank_account_2');
  }

  get document_type_text() {
    return (this.document_type === 'address') ? this.translate('proof_address') : this.translate('proof_bank_account');
  }

  get document_proof_text() {
    return (this.document_type === 'address') ? this.translate('address') : this.translate('bank_account');
  }
}
